import "jquery";
import * as ko from "knockout";
import { AccountStatementsViewModel } from "../ViewModels/AccountStatementsViewModel";
import { AccountStatementPdfsViewModel } from "../ViewModels/AccountStatementPdfsViewModel";
import { PdfApi } from "../Apis/PdfApi";

export class AccountStatements {
    private accountStatementsViewModel: AccountStatementsViewModel;
    private accountStatementPdfsViewModel: AccountStatementPdfsViewModel;
    pdfApi: PdfApi;
    private $accountStatementTab: JQuery;
    private $accountStatementPdfTab: JQuery;
    private $accountStatementDropDown: JQuery;
    private $balanceField: JQuery;

    constructor() {
        this.$accountStatementTab = $("#accountStatementTab");
        this.$accountStatementPdfTab = $("#accountStatementPdfTab");
        this.$accountStatementDropDown = $("#accountStatementDropDown");
        this.$balanceField = $("#balanceField");
        this.accountStatementsViewModel = new AccountStatementsViewModel();
        this.accountStatementPdfsViewModel = new AccountStatementPdfsViewModel();
        this.pdfApi = PdfApi.getInstance();

        if (this.$accountStatementTab[0]) {
            ko.applyBindings(this.accountStatementsViewModel, this.$accountStatementTab[0]);
            if (this.$balanceField[0])
                ko.applyBindings(this.accountStatementsViewModel,this.$balanceField[0]);
        }

        if (this.$accountStatementPdfTab[0]) {
            ko.applyBindings(this.accountStatementPdfsViewModel, this.$accountStatementPdfTab[0]);
        }

        this.$accountStatementDropDown.change(() => {
            this.accountStatementsViewModel.updateTable();
        });
    }

    init(): void {
        this.accountStatementsViewModel.init();
        this.accountStatementPdfsViewModel.init();
        this.attachPdfDownloadJquery();
    }

    private attachPdfDownloadJquery(): void {
        const self = this;
        self.$accountStatementTab.on('click', '[id *= download]', function (e: any) {
            const id = $(this).attr('id');
            const fileName = $(this).attr('filename');
            const company = $(this).attr('company');
            const entryNo = Number.parseInt(id.split('download')[1]);
            self.pdfApi.downloadFile(entryNo, fileName, company);
        });
        self.$accountStatementPdfTab.on('click', '[id *= download]', function (e: any) {
            const id = $(this).attr('id');
            const fileName = $(this).attr('filename');
            const entryNo = Number.parseInt(id.split('download')[1]);
            const company = $(this).attr('company');
            self.pdfApi.downloadFile(entryNo, fileName,company);
        });
    }

}